var map = {
	"./testimonial-01.jpg": 509,
	"./testimonial-02.jpg": 2998,
	"./testimonial-03.jpg": 2355,
	"./testimonial-04.jpg": 8381,
	"./testimonial-05.jpg": 4583,
	"./testimonial-06.jpg": 7942,
	"./testimonial-07.jpg": 3170,
	"./testimonial-08.jpg": 6877,
	"./testimonial-09.jpg": 6526,
	"./testimonial-10.jpg": 5497,
	"./testimonial-11.jpg": 5467,
	"./testimonial-12.jpg": 3157,
	"./testimonial-13.jpg": 3636,
	"./testimonial-14.jpg": 2095
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5928;